@if (type() !== filterTypes.OPTIONAL) {
    <mat-accordion
        multi
        displayMode="flat"
        togglePosition="before">
        <mat-expansion-panel opened>
            <mat-expansion-panel-header>
                <mat-panel-title>{{ 'Default Team' }}</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-chip-listbox
                st-click-stop-propagation
                class="st-filter-manage-team-members-options"
                [ngModel]="selectedTeam()">
                @for (team of globalTablesService?.GroupsArray; track team) {
                    <mat-chip-option
                        class="st-filter-manage-team-members-options-item"
                        [value]="team.ID"
                        (selectionChange)="filterTeamMembers($event, 'team')">
                        {{ team.Description }}
                    </mat-chip-option>
                }
            </mat-chip-listbox>
        </mat-expansion-panel>
        <mat-divider class="st-filter-divider" />
        <mat-expansion-panel opened>
            <mat-expansion-panel-header>
                <mat-panel-title>{{ 'Role' }}</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-chip-listbox
                st-click-stop-propagation
                class="st-filter-manage-team-members-options"
                [ngModel]="selectedRole()">
                @for (role of securityRoles(); track role) {
                    <mat-chip-option
                        class="st-filter-manage-team-members-options-item"
                        [value]="role.ID"
                        (selectionChange)="filterTeamMembers($event, 'role')">
                        {{ role.Description }}
                    </mat-chip-option>
                }
            </mat-chip-listbox>
        </mat-expansion-panel>
        <mat-divider class="st-filter-divider" />
        <mat-expansion-panel opened>
            <mat-expansion-panel-header>
                <mat-panel-title>{{ 'Status' }}</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-chip-listbox
                st-click-stop-propagation
                class="st-filter-manage-team-members-options"
                [ngModel]="selectedStatus()">
                @for (status of filterMemberStatus; track status) {
                    <mat-chip-option
                        class="st-filter-manage-team-members-options-item"
                        [value]="status.StatusNumber"
                        (selectionChange)="filterTeamMembers($event, 'status')">
                        {{ status.StatusName }}
                    </mat-chip-option>
                }
            </mat-chip-listbox>
        </mat-expansion-panel>
    </mat-accordion>
}
